<template>
  <div class="woo-help-playlist-wrapper">
    <div v-if="searching">
      <div class="woo-drawer-header" style="padding-bottom: 8px;">
        <v-text-field
          v-model="search"
          class="woo-text-search-input"
          placeholder="Search help..."
          ref="search"
          filled
          hide-details
          background-color="white"
          outlined
          rounded
          @keydown.esc="resetSearch"
        />
        <div class="woo-icon" style="position: absolute; right: 0px; top: calc(50% - 20px);">
          <v-icon @click="resetSearch">mdi-close</v-icon>
        </div>
      </div>
      <div v-if="topicId" style="margin-top: 10px;">
        <div class="woo-drawer-header-title">Help</div>
        <div style="margin-top: 10px;">{{ topicTitle }}</div>
      </div>
    </div>
    <div v-else-if="topicId">
      <div class="woo-drawer-header" style="margin-bottom: 10px;">
        <div style="flex: 1; margin-left: -16px;">
          <div class="woo-icon">
            <v-icon color="black" @click="goBack">mdi-arrow-left</v-icon>
          </div>
        </div>
        <div style="display: flex; margin-right: -16px;">
          <div class="woo-icon">
            <v-icon @click="setSearching" style="margin-right: -16px;">mdi-magnify</v-icon>
          </div>
          <div class="woo-icon">
            <v-icon @click="onCloseHelp">mdi-close</v-icon>
          </div>
        </div>
      </div>
      <div class="woo-drawer-header-title">Help</div>
      <div style="margin-top: 10px;">{{ topicTitle }}</div>
    </div>
    <div v-else>
      <div class="woo-drawer-header">
        <div class="woo-drawer-header-title">Help</div>
        <div style="display: flex; margin-right: -16px;">
          <div class="woo-icon">
            <v-icon @click="setSearching" style="margin-right: -16px;">mdi-magnify</v-icon>
          </div>
          <div class="woo-icon">
            <v-icon @click="onCloseHelp">mdi-close</v-icon>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!videoPlaylist" style="flex: 1;">
      <v-list flat class="woo-help-topic-wrapper">
        <span v-for="(topic, $topicIndex) in filteredTopics" :key="$topicIndex">
          <v-list-item
            class="woo-help-topic" v-if="topic.isContactForm">
            <contact-form :tutorial="tutorial" :step="activeStep"/>
          </v-list-item>
          <v-list-item
            v-else
            class="woo-help-topic"
            @click="selectTopicWithTimeout(topic)"
          >
            <v-list-item-content
              align="left"
              class="woo-help-topic-title"
              v-ripple="{ class: `woo-ripple` }"
            >
              <a :href="topic.url" target="_blank" class="woo-help-topic-action">
                <v-row align="center">
                  <v-col align="left" class="woo-help-topic-title-label">
                    <v-row class="compact">
                      <v-col v-if="topic.icon" class="icon">
                        <v-icon>
                          {{ topic.icon }}
                        </v-icon>
                      </v-col>
                      <v-col>
                        <text-highlight :queries="queries">{{topic.display_name}}</text-highlight>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col align="right" cols="2" v-if="topic.multiTopic">
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-col>
                </v-row>
              </a>
            </v-list-item-content>
          </v-list-item>
          <v-list v-if="topic.hasSubTopics" style="padding-left: 10px; background-color: white; border-radius: 4px;">
            <v-list-item
              v-for="(subTopic, $subTopicIndex) in topic.subTopics"
              :key="$subTopicIndex"
              @click="selectTopicWithTimeout(subTopic)"
              >
              <v-list-item-content
                align="left"
                class="woo-help-topic-title"
                v-ripple="{ class: `woo-ripple` }"
              >
                <a :href="subTopic.url" target="_blank" class="woo-help-topic-action">
                  <v-row align="center">
                    <v-col align="left" class="woo-help-topic-title-label">
                      <v-row class="compact">
                        <v-col v-if="subTopic.icon" class="icon">
                          <v-icon>
                            {{ subTopic.icon }}
                          </v-icon>
                        </v-col>
                        <v-col>
                          <text-highlight :queries="queries">{{subTopic.display_name}}</text-highlight>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </a>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </span>
      </v-list>
    </div>
    <div v-if="!videoPlaylist" class="woo-help-link">
      <a :href="helpLink" target="_blank">
        <v-icon>mdi-link-variant</v-icon>
      </a>
    </div>
    <div class="woo-help-video-playlist-wrapper" v-if="videoPlaylist">
      <div class="woo-help-video-playlist">
        <video-player
          :onClose="onCloseVideo"
          :video="video"
          :options="getVideoOptions(video)"
          :title="video.display_name"
          :manualLoop="false"
          :showRepeatBar="true"
          v-for="(video, $videoIndex) in videoPlaylist"
          :key="video.id"
          :ref="`help_video_${$videoIndex}`"
          :isHelpVideo="true"
          class="woo-help-video-playlist-item help-video"
          :class="{ active: $videoIndex == activeVideoIndex }"
          :hidePrevButton="$videoIndex == 0"
        >
          <v-row class="woo-playlist-navigation active">
            <v-col v-for="(video, $index) in videoPlaylist" :key="video.id">
              <div class="microstep"></div>
              <span v-if="isLoaded">
                <div
                  class="completed"
                  :style="{
                    width: getProgressForVideo($index),
                  }"
                ></div>
              </span>
            </v-col>
          </v-row>
        </video-player>
        <div class="woo-help-video-playlist-conformation-wrapper">
          <div>Did that answer your question?</div>
          <div
            class="woo-button black woo-help-video-playlist-conformation"
            @click="answerYes"
          >
            YES
            <div class="subtitle">Back to main tutorials</div>
          </div>
          <div
            class="woo-button woo-help-video-playlist-conformation white"
            @click="answerNo"
          >
            NO
            <div class="subtitle">I need help with something else</div>
          </div>
        </div>
        <div style="position: absolute; bottom: 2rem; left: 2rem;">
          <a :href="helpLink" class="woo-help-link" target="_blank">
            <v-icon>mdi-link-variant</v-icon>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EventHub, { Events } from '@/helpers/EventHub';
import VideoPlayer from './VideoPlayer.vue';
import Db from '@/helpers/Db';
import TextHighlight from 'vue-text-highlight';
import HelperMethods from '@/helpers/HelperMethods';
import ContactForm from './forms/ContactForm.vue';

export default {
  components: { VideoPlayer, TextHighlight, ContactForm },
  name: 'HelperPlaylist',
  data() {
    return {
      search: '',
      searching: false,
      topics: [],
      videoPlaylist: undefined,
      topicId: null,
      topicTitle: '',
      isLoaded: false,
      activeVideoIndex: undefined,
    };
  },
  computed: {
    activeStep() {
      if (!this.tutorial) return null;

      return Db.findStepById({
        tutorial: this.tutorial,
        stepId: this.$route.query.s,
      });
    },
    tutorial() {
      return Db.getFullTutorialBySlug(this.$route.params.id);
    },
    helpTopics() {
      const step = this.activeStep;
      let helpContent = null;

      if (!step) {
        helpContent = Db.getHelp();
      } else {
        // The help codes are at the microstep level, but they
        // seem to be the same so we'll dedupe here
        const helpCodes = step.microsteps.reduce((acc, ms) => {
          return HelperMethods.unique([...acc, ...(ms.help_groups) || []])
        }, []);

        helpContent = Db.getHelp(helpCodes);
      }

      return helpContent;
    },
    helpLink() {
      const tokens = [];

      const family = Db.findHelpTopicById(this.topicId);

      if (family) {
        const { parent, child } = family;

        // Main topic
        if (parent) {
          tokens.push(parent.id);

          // Sub topic
          if (child) {
            tokens.push(child.id);
          }

          // Microstep
          if (this.videoPlaylist) {
            const currentVideo = this.videoPlaylist[this.activeVideoIndex];
            
            if (currentVideo) {
              tokens.push(currentVideo.id);
            }
          }
        }
      }

      return `/help/${tokens.join('/')}`;
    },
    filteredTopics() {
      if (this.search.length === 0) return this.topics;

      // Here we need to flatten the list
      return this.topics.reduce((acc, t) => {
        // Not filtering
        if (this.search.length === 0) {
          return [...acc, t];
        }

        const matchesThisTopic = HelperMethods.matchText({
          text: t.display_name,
          query: this.search,
        });

        // We're inside a topic, we can filter topics directly
        if (this.topicId) {
          if (matchesThisTopic) {
            return [...acc, t]
          } else {
            return acc;
          }
        }

        // If we have a single child, the parent is the same so 
        // we don't need to dupe
        let children = (t.topics || []);
        if (children.length === 1) {
          children = [];
        }

        // If not inside a topic, we need to return the parent if any of 
        // its children match also
        const matchingChildren = children.filter(s => HelperMethods.matchText({
          text: s.display_name,
          query: this.search,
        }));

        // No matching parent or children
        if (!matchesThisTopic && matchingChildren.length === 0) {
          return acc;
        }
        
        const result = [...acc, {
          ...t,
          subTopics: matchingChildren,
          hasSubTopics: matchingChildren.length > 0,
        }]

        return result;
      }, []);
    },
    queries() {
      return [this.search];
    },
  },
  watch: {
    activeVideoIndex(newValue, oldValue) {
      this.updateUrl()

      if (newValue === -1 || newValue === undefined) {
        return;
      }
      
      if (newValue !== oldValue) {
        this.$refs[`help_video_${newValue}`][0].player.play();
      }
      
      if (oldValue >= 0) {
        this.$refs[`help_video_${oldValue}`][0].player.pause();
        this.$refs[`help_video_${oldValue}`][0].player.currentTime(0);
      }
    },
    topicId() {
      this.updateUrl()
    },
    videoPlaylist() {
      setTimeout(() => {
        this.playVideo();
      }, 500);
    },
  },
  mounted() {
    this.resetHelpDrawer();
    EventHub.$on(Events.ResetHelpDrawer, this.resetHelpDrawer);
    EventHub.$on(Events.PlayNextHelpVideo, this.playNextHelpVideo);
    EventHub.$on(Events.PlayPreviousHelpVideo, this.playPreviousHelpVideo);
  },
  destroyed() {
    EventHub.$off(Events.ResetHelpDrawer, this.resetHelpDrawer);
    EventHub.$off(Events.PlayNextHelpVideo, this.playNextHelpVideo);
    EventHub.$off(Events.PlayPreviousHelpVideo, this.playPreviousHelpVideo);
  },
  methods: {
    setSearching() {
      this.search = '';
      this.searching = true;
      
      const waitTillVisible = setInterval(() => {
        if (this.$refs.search) {
          clearInterval(waitTillVisible);
          this.$nextTick(this.$refs.search.focus)
        }
      }, 100);
    },
    resetSearch() {
      this.search = '';
      this.searching = false;
    },
    goBack() {
      if (this.$attrs.urlAware) {
        this.$router.push('/help');
        setTimeout(() => {
          this.resetHelpDrawer();
        }, 100)
      } else {
        this.resetHelpDrawer();
      }
    },
    onCloseHelp() {
      if (this.$attrs.onCloseHelp) {
        this.$attrs.onCloseHelp();
      }
    },
    updateUrl() {
      if (!this.$attrs.urlAware) return;
      this.$router.push(this.helpLink)
      .catch(() => {
        // ignore these errors for now
      });
    },
    answerYes() {
      HelperMethods.postGoogleEvent({
        event: 'help_topic',
        category: this.topicId,
        label: 'AnsweredQuestionYes',
      });

      EventHub.$emit(Events.ShowHelp);
    },
    answerNo() {
      HelperMethods.postGoogleEvent({
        event: 'help_topic',
        category: this.topicId,
        label: 'AnsweredQuestionNo',
      });

      this.resetHelpDrawer();
    },
    onCloseVideo() {
      if (this.$attrs.urlAware) {
        this.$router.replace('/help');
        setTimeout(() => {
          this.resetHelpDrawer();    
        }, 100)
        return;
      }

      this.resetHelpDrawer();
    },
    resetHelpDrawer() {
      this.topics = [...this.helpTopics];
      this.videoPlaylist = undefined;

      if (this.$attrs.urlAware) {
        const { parentId, childId, microstepId } = this.$route.params;
        
        // Set the initial state to that of the URL
        const family = Db.findHelpTopicById(childId || parentId);

        if (family) {
          const topic = family.child || family.parent;
          const videoIndex = topic?.microsteps?.findIndex(s => s.id === microstepId);
          this.selectTopic(topic, videoIndex === -1 ? null : videoIndex);
          return;
        }
      }
      
      this.topicId = null;
      this.topicTitle = '';
      this.activeVideoIndex = undefined;
    },
    selectTopic(topic, initialVideoIndex = 0) {
      let selectedTopic = topic;

      // If we have a single topic, select it
      if (topic.topics?.length === 1) {
        selectedTopic = topic.topics[0];
      }

      this.topicTitle = selectedTopic.display_name;
      this.topicId = selectedTopic.refId || selectedTopic.id;

      HelperMethods.postGoogleEvent({
        event: 'help_topic',
        category: this.topicId,
        label: 'View',
      });

      if (selectedTopic.topics) {
        // We're entering a topic with children so we should clear
        // the search
        this.search = '';
        this.searching = false;
        this.topics = [...selectedTopic.topics];
      }

      if (selectedTopic.microsteps) {
        this.isLoaded = false;
        this.videoPlaylist = [...selectedTopic.microsteps];

        const refInterval = setInterval(() => {
          if (
            this.$refs['help_video_0'] &&
            this.$refs['help_video_0'].length > 0
          ) {
            this.isLoaded = true;
            this.activeVideoIndex = initialVideoIndex || 0;
            clearInterval(refInterval);
          }
        });
      }

      // Build the category from the current tutorial / step / microstep
      const categoryTokens = [this.tutorial ? this.tutorial.display_name : 'Help Page'];
      const { v: microstepId, s: stepId } = this.$route.query || {};

      if (this.tutorial && microstepId && stepId) {
        // First get the step
        const step = Db.findStepById({ tutorial: this.tutorial, stepId });
        
        if (step) {
          // Now find the microstep
          const microstep = step.microsteps.find(s => s.id === microstepId);
          if (microstep) {
            categoryTokens.push(step.display_name)
            categoryTokens.push(microstep.display_name)
          }
        }
      }

      // Log Event to GA if coming from a tutorial
      HelperMethods.postGoogleEvent({
        event: 'help_topic_viewed',
        // The category will be '<tutorial> / <step> / <microstep>'
        // or simply "Help Page" if accessed from the help page directly
        category: categoryTokens.join(' / '),
        label: selectedTopic.display_name
      })
    },
    selectTopicWithTimeout(topic) {
      setTimeout(() => {
        this.selectTopic(topic);
      }, 100)
    },
    playVideo() {
      if (this.activeVideoIndex >= 0)
        this.$refs[`help_video_${this.activeVideoIndex}`][0].player.play();
    },
    pauseVideo() {
      if (this.activeVideoIndex >= 0)
        this.$refs[`help_video_${this.activeVideoIndex}`][0].player.pause();
    },
    playNextHelpVideo() {
      if (this.activeVideoIndex < this.videoPlaylist?.length - 1) {
        this.pauseVideo();
        this.activeVideoIndex++;
      } else if (this.activeVideoIndex === this.videoPlaylist?.length - 1) {
        this.pauseVideo();
        this.activeVideoIndex = -1;
      }
    },
    playPreviousHelpVideo() {
      if (this.activeVideoIndex > 0) {
        this.pauseVideo();
        this.activeVideoIndex--;
        this.playVideo();
      } else {
        this.resetHelpDrawer();
      }
    },
    getProgressForVideo(videoIndex) {
      if (this.isLoaded) {
        if (videoIndex === this.activeVideoIndex) {
          return `${this.$refs[`help_video_${videoIndex}`][0].currentTime}%`;
        } else if (videoIndex < this.activeVideoIndex) {
          return '100%';
        } else {
          return '0';
        }
      } else {
        return '0';
      }
    },
    getVideoOptions(microstep) {
      return HelperMethods.getVideoOptions({
        microstep,
        tutorialId: this.tutorial?.id,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.woo-icon {
  cursor: pointer;
  
  .v-icon {
    font-size: 32px !important;
    color: black;
  }

  &:not(:first-of-type) {
    margin-left: 0;
  }
  &:not(:last-of-type) {
    margin-right: 0;
  }
}

.woo-help-playlist-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0px 2rem;
  text-align: left;
}

.woo-help-link {
  margin-bottom: 2rem;
  text-align: right;
  .v-icon {
    color: #ddd;
  }
}

.woo-drawer-header {
  padding: 30px 0px 6px 0px;
  position: relative;
  display: flex;
  height: 76px;
  align-items: center;

  .woo-drawer-close {
    margin-right: -20px;
  }
}

.woo-drawer-header-title {
  flex: 1;
  font-weight: 900;
  font-size: 24px;
  text-align: left;
  padding: 4px 10px 4px 0px;
}

.woo-text-search-input {
  margin: 0px;
  background-color: white;
  width: 100%;
}

.woo-help-topic {
  padding: 0;
  margin-top: 1rem;
}

.woo-help-topic-title {
  background-color: #fff;
  min-height: 64px;
  padding: 1rem;
  border-radius: 0.25rem;

  .v-icon {
    color: black;
  }
}

.woo-help-topic-title-label {
  margin: auto;
  line-height: 1.3rem;
  padding-left: 24px;
  .compact {
    padding: 0;
    .col {
      padding: 0.5rem;
      margin: auto;
    }
    .icon {
      max-width: 2rem;
    }
  }
}

.woo-help-topic-wrapper {
  flex: 1;
}

.woo-help-topic-action {
  color: black;
  margin-bottom: 0px;
}


.woo-help-video-playlist {
  display: inline-flex;

  &-conformation {
    cursor: pointer;
    border-radius: 0.25rem;
    font-size: 16px !important;
    padding: 1.125rem;
    margin-top: 1rem;
    width: 100%;
    &-wrapper {
      margin-top: 24px;
      width: calc(100vw - 4rem);
    }
    .white {
      background: #fff;
      color: black;
    }
    .subtitle {
      font-weight: 400;
    }
  }
}
</style>
<style lang="scss">
@media screen and (min-width: 30rem) {
  .woo-help-topic-title-label {
    .compact {
      .icon {
        max-width: 2.5rem !important;
      }
    }
  }
}
</style>
